import React from 'react';
import { Modal } from 'react-bootstrap';
import { getFileUrl } from 'utils/file';
import useTranslation from 'hooks/useTranslation';
import { ReactComponent as GenAIFeedback1Icon } from 'assets/images/gen-ai-feedback-1.svg';
import { ReactComponent as GenAIFeedback2Icon } from 'assets/images/gen-ai-feedback-2.svg';
import { ReactComponent as OrangeRightArrowIcon } from 'assets/images/arrow-right-orange.svg';
import styles from './GenAIImageFeedback.module.scss';

export default function GenAIImageFeedback({
  onClose,
  variants = [],
}) {
  const { tGenAIImageFeedback } = useTranslation();

  const getFileId = (variant) => variant.highResFileId || variant.lowResFileId;

  const handleBuyMoreCoins = () => {
    onClose();
    // Navigate to add design page
    window.location.href = '/add-design';
  };

  const handleOurServices = () => {
    onClose();
    // Navigate to services page
    window.open('https://betates.com', '_blank');
  };

  // Show first 2 variants for display
  const displayVariants = variants.slice(0, 2);

  return (
    <Modal
      show
      onHide={onClose}
      backdrop="static"
      centered
      className={styles.modal}
    >
      <Modal.Header closeButton>
        <Modal.Title>{tGenAIImageFeedback('title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className={styles.container}>
          <div className={styles.variantsContainer}>
            {displayVariants.map((variant, index) => (
              <div key={variant.id} className={styles.variant}>
                <img
                  src={getFileUrl(getFileId(variant))}
                  alt={`Variant ${index + 1}`}
                  className={styles.variantImage}
                />
              </div>
            ))}
          </div>

          <div className={styles.cardsContainer}>
            <div className={styles.card}>
              <div className={styles.cardIcon}>
                <GenAIFeedback1Icon />
              </div>
              <div className={styles.cardContent}>
                <div className={styles.cardText}>
                  {tGenAIImageFeedback('buyMoreCoinsText')}
                </div>
                <button type="button" className={styles.cardButton} onClick={handleBuyMoreCoins}>
                  <span>
                    {tGenAIImageFeedback('buyMoreCoinsButton')}
                  </span>
                  <OrangeRightArrowIcon />
                </button>
              </div>
            </div>

            <div className={styles.card}>
              <div className={styles.cardIcon}>
                <GenAIFeedback2Icon />
              </div>
              <div className={styles.cardContent}>
                <div className={styles.cardText}>
                  {tGenAIImageFeedback('ourServicesText')}
                </div>
                <button type="button" className={styles.cardButton} onClick={handleOurServices}>
                  <span>
                    {tGenAIImageFeedback('ourServicesButton')}
                  </span>
                  <OrangeRightArrowIcon />
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
